import { createSelector } from 'reselect';
import { getInsurances } from './getInsurances';

export const getCardFinderInsurances = createSelector([getInsurances], (insurances) => {
  return insurances.filter(({ source }) => source === 'cardfinder');
});
